import { ApiErrorResponse, ErrorDetail } from '../../../../shared/types/api.types'

export const USPS_ZIP_PLUS_FOUR_REQUIRED_CODE = 'usps_address_zip_plus_four_required'

export interface ZipPlusFourValidationSignal {
  enforceZipPlus4: boolean
  suggestedZipPlus4: string | null
  dpvConfirmation: string | null
}

/**
 * Inspects a rejected validateUspsAddress error payload and derives whether we should
 * require ZIP+4 on retry, along with any USPS-suggested +4 to prefill.
 */
export function parseZipPlusFourValidationSignal(
  error: ApiErrorResponse | null | undefined
): ZipPlusFourValidationSignal {
  if (!error || error.error !== USPS_ZIP_PLUS_FOUR_REQUIRED_CODE) {
    return { enforceZipPlus4: false, suggestedZipPlus4: null, dpvConfirmation: null }
  }

  const details: ErrorDetail[] = Array.isArray(error.details) ? error.details : []
  const plus4Detail = details.find((detail) => detail.field === 'ZIPPlus4')
  const dpvDetail = details.find((detail) => detail.field === 'DPVConfirmation')

  const plus4 = plus4Detail?.description?.replace(/\D/g, '').slice(0, 4) ?? ''

  return {
    enforceZipPlus4: true,
    suggestedZipPlus4: plus4.length === 4 ? plus4 : null,
    dpvConfirmation: dpvDetail?.description ?? null
  }
}
